import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';

import { formatCurrency, isEmptyObject } from '../../../../../utils/utils';
import { trans } from '../../../../../localization/index';
import PageTable, {
  PageTableCell,
  PageTableHeader,
  PageTableRow,
} from '../../../../../components/Table/PageTable';
import {
  EnumDeliveryDiscountType,
  EnumMerchantPaidStatus,
} from '../../../../../constants/enum';
import OtherDiscountTooltip from './OtherDiscountTooltip';
import OutOfStockItem from './OutOfStockItem';


function ToppingDishItem({ options }) {
  return (
    <div className="dish-topping">
      {options &&
        options.map((topping) => {
          const attributeTopping = topping.attributes
            .map(attribute => attribute.name)
            .join();
          return (
            <p key={topping.id}>
              <span className="color-black">
                <i className="fa fa-check mr-1" />
                {topping.name}
              </span>
              : {attributeTopping}
            </p>
          );
        })}
    </div>
  );
}

class OrderDetailTable extends Component {
  static renderHeader() {
    const columns = [
      {
        id: 'number',
        label: trans('mod_header_stt'),
        width: '5%',
        textAlign: 'center',
      },
      {
        id: 'dish_name',
        label: trans('mod_detail_dish_name'),
        width: '40%',
        textAlign: 'left',
      },
      {
        id: 'quantity',
        label: trans('mod_detail_quantity'),
        width: '10%',
        textAlign: 'center',
      },
      {
        id: 'unit_price',
        label: trans('mod_detail_unit_price'),
        width: '15%',
        textAlign: 'right',
      },
      {
        id: 'total_price',
        label: trans('mod_detail_total_price'),
        width: '15%',
        textAlign: 'right',
      },
      {
        id: 'out_of_stock',
        label: trans('mod_detail_out_of_stock'),
        width: '15%',
        textAlign: 'center',
      },
    ];

    return <PageTableHeader columns={columns} />;
  }

  renderRow = (row, index) => {
    const {
      outOfStockOrder,
      isHaveChangeOrder,
      handleOpenOutOfStockModal,
    } = this.props;
    const {
      price,
      out_of_stock: outOfStock,
      id,
      note: dishNote,
      quantity,
      dish,
      options,
      original_price: originalPrice,
    } = row;
    const { dishes: listOutOfStock = [] } = outOfStockOrder;
    const currentOfStock = listOutOfStock.find(
      dishItem => dishItem.dishId === dish.id,
    );
    const isOutOfStock = !isEmptyObject(currentOfStock) ? true : outOfStock > 0;
    const outOfStockObj = {
      orderDishId: id,
      dishId: dish.id,
    };
    return (
      <PageTableRow key={id}>
        <PageTableCell textAlign="center">{index}</PageTableCell>
        <PageTableCell textAlign="left">
          <strong className="color-black">{dish.name}</strong>
          <ToppingDishItem options={options} />
          <div className="font12">
            <i>{dishNote}</i>
          </div>
        </PageTableCell>
        <PageTableCell textAlign="center">
          <span className="font12">{quantity}</span>
        </PageTableCell>
        <PageTableCell textAlign="right">
          <span className="font12">{price.text}</span>
          <br />
          {price.value !== originalPrice.value && (
            <span className="font12 old-price">{originalPrice.text}</span>
          )}
        </PageTableCell>
        <PageTableCell textAlign="right">
          <span className="font12">
            {formatCurrency(quantity * price.value, price.unit)}
          </span>
        </PageTableCell>
        <PageTableCell textAlign="center">
          <OutOfStockItem
            isOutOfStock={isOutOfStock}
            handleOpenOutOfStockModal={handleOpenOutOfStockModal}
            currentOfStock={currentOfStock}
            isHaveChangeOrder={isHaveChangeOrder}
            outOfStockObj={outOfStockObj}
          />
        </PageTableCell>
      </PageTableRow>
    );
  };

  renderExtraRowInfo = () => {
    const { itemDetail } = this.props;
    const {
      group_items: groupItems,
      total_value_detail: totalValueDetail,
      order_value: orderValue,
      post_item_discount_value: postItemDiscountValue,
      commission,
      customer_bill: customerBill,
      pay_to_merchant: payToMerchant,
      merchant_discount_value: merchantDiscountValue,
      merchant_discounts: merchantDiscounts = [],
    } = itemDetail;
    const discountDish = merchantDiscounts.find(
      discount => discount.type === EnumDeliveryDiscountType.ITEM_DISCOUNT.id,
    );
    const otherDiscounts = merchantDiscounts.filter(
      discount => discount.type !== EnumDeliveryDiscountType.ITEM_DISCOUNT.id,
    );
    const totalItem = groupItems
      .map(group => group.items.total_count)
      .reduce((a, b) => a + b);

    return (
      <React.Fragment>
        <PageTableRow>
          <PageTableCell
            textAlign="right"
            className="font-weight-bold"
            colSpan="4"
          >
            {trans('mod_detail_total_unit_price', [totalItem])}
          </PageTableCell>
          <PageTableCell textAlign="right" className="font-weight-bold">
            {orderValue}
          </PageTableCell>
          <PageTableCell />
        </PageTableRow>
        {!isEmptyObject(discountDish) && (
          <PageTableRow>
            <PageTableCell
              textAlign="right"
              className="font-weight-bold"
              colSpan="4"
            >
              {trans('mod_detail_discount_item')}
            </PageTableCell>
            <PageTableCell
              textAlign="right"
              className="font-weight-bold text-danger"
            >
              -{discountDish.text}
            </PageTableCell>
            <td />
          </PageTableRow>
        )}
        {!isEmptyObject(merchantDiscountValue) &&
          !isEmptyObject(otherDiscounts) && (
            <PageTableRow>
              <PageTableCell
                textAlign="right"
                className="font-weight-bold discount-different"
                colSpan="4"
              >
                {trans('mod_detail_discount_different')}{' '}
                <i className="far fa-question-circle" data-tip="tooltip" />
                <ReactTooltip>
                  <OtherDiscountTooltip
                    otherDiscounts={otherDiscounts}
                    merchantDiscountValue={merchantDiscountValue}
                  />
                </ReactTooltip>
              </PageTableCell>
              <PageTableCell
                textAlign="right"
                className="font-weight-bold text-danger"
              >
                -{merchantDiscountValue.text}
              </PageTableCell>
              <td />
            </PageTableRow>
          )}
        <PageTableRow>
          <PageTableCell
            textAlign="right"
            className="font-weight-bold"
            colSpan="4"
          >
            {trans('mod_detail_total_money', [totalItem])}
          </PageTableCell>
          <PageTableCell textAlign="right" className="font-weight-bold">
            {postItemDiscountValue.text}
          </PageTableCell>
          <td />
        </PageTableRow>
        {!isEmptyObject(commission) && commission.detail.value > 0 && (
          <PageTableRow>
            <PageTableCell
              textAlign="right"
              className="font-weight-bold"
              colSpan="4"
            >
              {trans('mod_detail_total_commission')}
            </PageTableCell>
            <PageTableCell
              textAlign="right"
              className="font-weight-bold text-danger"
            >
              -{commission.text}
            </PageTableCell>
            <td />
          </PageTableRow>
        )}
        {!isEmptyObject(customerBill) && customerBill.packing_fee > 0 && (
          <PageTableRow>
            <PageTableCell
              textAlign="right"
              className="font-weight-bold"
              colSpan="4"
            >
              {trans('mod_detail_pack_fee')}
            </PageTableCell>
            <PageTableCell
              textAlign="right"
              className="font-weight-bold text-danger"
            >
              +{formatCurrency(customerBill.packing_fee, totalValueDetail.unit)}
            </PageTableCell>
            <PageTableCell />
          </PageTableRow>
        )}
        {!isEmptyObject(totalValueDetail) && totalValueDetail.value > 0 && (
          <PageTableRow>
            <PageTableCell
              textAlign="right"
              className="font-weight-bold"
              colSpan="2"
            >
              {trans('mod_detail_total')}:
            </PageTableCell>
            <PageTableCell
              textAlign="center"
              className="font-weight-bold text-red"
            >
              {totalItem}
            </PageTableCell>
            <PageTableCell />
            <PageTableCell
              textAlign="right"
              className="font-weight-bold text-red position-relative"
            >
              {totalValueDetail.text}
              {payToMerchant.state === EnumMerchantPaidStatus.PAID && (
                <span className="icon icon-paid" />
              )}
            </PageTableCell>
            <PageTableCell />
          </PageTableRow>
        )}
      </React.Fragment>
    );
  };

  render() {
    const { itemDetail } = this.props;
    const { group_items: groupItems } = itemDetail;
    let itemList = [];
    groupItems.forEach((group) => {
      itemList = itemList.concat(...group.items.order_dish);
    });
    const table = {
      itemList,
      totalSize: itemList.length,
    };

    return (
      <PageTable
        renderHeader={OrderDetailTable.renderHeader}
        renderRow={this.renderRow}
        table={table}
        isPagination={false}
        renderExtraRowInfo={this.renderExtraRowInfo}
        isShowFooter={false}
      />
    );
  }
}
export default OrderDetailTable;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/components/OrderDetailTable.jsx